import { useTheme } from '@/hooks/useTheme';

interface DarkModeToggleProps {
  className?: string;
}

export default function DarkModeToggle({ className = '' }: DarkModeToggleProps) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';

  return (
    <button
      onClick={toggleTheme}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Light mode' : 'Dark mode'}
      className={`relative w-9 h-9 flex items-center justify-center rounded-lg transition-colors duration-200 cursor-pointer ${
        isDark
          ? 'text-amber-400 hover:bg-stone-700'
          : 'text-stone-500 hover:bg-stone-100'
      } ${className}`}
    >
      {/* Sun icon — shown in dark mode */}
      <i
        className={`ri-sun-line text-lg absolute transition-all duration-300 ${
          isDark ? 'opacity-100 rotate-0 scale-100' : 'opacity-0 rotate-90 scale-75'
        }`}
      />
      {/* Moon icon — shown in light mode */}
      <i
        className={`ri-moon-line text-lg absolute transition-all duration-300 ${
          isDark ? 'opacity-0 -rotate-90 scale-75' : 'opacity-100 rotate-0 scale-100'
        }`}
      />
    </button>
  );
}
